<template>
    <div>
        <div class="flex flex-col items-center bg-gray-200 mb-6 relative p-4 pt-3 lg:flex-row lg:justify-between lg:px-8 lg:pt-6"
            v-for="(room, index) in rooms"
            :key="'r' + index + 'a' + room.adults + 'c' + room.children">
            <counter-button
                class="mb-4 lg:mb-0"
                :name="'adults_room_' + index"
                :initial-count="room.adults"
                :max-count="MAX_PER_ROOM"
                :can-increment="counterCanIncrement(room)"
                @change="room.adults = $event">
                {{ lang.counter_adults }}
            </counter-button>

            <counter-button
                :name="'children_room_' + index"
                :initial-count="room.children"
                :max-count="MAX_PER_ROOM"
                :can-increment="counterCanIncrement(room)"
                @change="room.children = $event">
                {{ lang.counter_children }} <span class="text-blue-500 normal-case tracking-normal font-body">({{ lang.counter_children_note }})</span>
            </counter-button>

            <button
                class="absolute bg-gray-500 right-0 top-0 rotate-45 scale-75 transform rounded-full m-1 p-1"
                v-if="index !== 0"
                type="button"
                @click="remove(index)">
                <img src="/assets/frontend/svg/icon_plus.svg" alt="">
            </button>

            <p class="absolute text-navigation -rotate-90 transform origin-bottom-left left-0 bottom-0 mb-0 text-gray-300 leading-loose">{{ lang.room }} {{ index + 1 }}</p>
        </div>

        <button
            v-if="rooms.length < maxRooms"
            type="button"
            class="bg-gray-200 text-label px-4 w-full relative mb-8"
            :style="{ paddingTop: '0.6rem', paddingBottom: '0.75rem', }"
            @click="add">
            {{ btnText }} <img class="absolute pr-2 right-0 top-0 transform translate-y-1/2" src="/assets/frontend/svg/icon_plus_blue.svg" alt="">
        </button>
    </div>
</template>

<script>
import CounterButton from './CounterButton';

const MAX_PER_ROOM = 2;

export default {
    name: 'add-room',
    components: { 'counter-button': CounterButton },
    props: ['btnText', 'roomsData', 'lang'],

    data: () => ({
        rooms: [],
        maxRooms: 7
    }),

    watch: {
        rooms: {
            handler(val) {
                this.$emit('change', val);
            },
            deep: true,
        }
    },

    created() {
        this.MAX_PER_ROOM = MAX_PER_ROOM;
    },

    mounted() {
        this.rooms = this.roomsData;
    },

    methods: {
       add() {
            this.rooms.push({ adults: 2, children: 0 });
       },

       remove(index) {
            this.rooms.splice(index, 1);
       },

        counterCanIncrement(room) {
            return this.peopleRemainingInRoom(room) > 0;
        },

       peopleRemainingInRoom(room) {
           return this.MAX_PER_ROOM - (room.adults + room.children);
       }
    }
}
</script>
